/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Ingredient_RemoveInputs */

const en_editor_ingredient_remove = /** @type {(inputs: Editor_Ingredient_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove ingredient`)
};

const de_editor_ingredient_remove = /** @type {(inputs: Editor_Ingredient_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zutat entfernen`)
};

/**
* | output |
* | --- |
* | "Remove ingredient" |
*
* @param {Editor_Ingredient_RemoveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_ingredient_remove = /** @type {((inputs?: Editor_Ingredient_RemoveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Ingredient_RemoveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_editor_ingredient_remove(inputs)
	return en_editor_ingredient_remove(inputs)
});